<div
  class="tipo-de-obra-content titles"
  appDropdownToggle
  #dropdown="dropdownToggle"
  (click)="filtroDetalhesObra.length > 0 && dropdown.toggle()"
  tabindex="0"
>
  <div class="icon-text">
    <span class="icon-circle">
      <img
        class="img-icon"
        src="{{
          BASE_IMG_URL
        }}assets/filtro-lateral-busca/detalhes_obra.svg"
        alt=""
        width="22"
        height="22"
      />
    </span>
    <h2>Detalhes da obra</h2>
  </div>
  <a
    class="btn tipo-de-obra-link"
    data-bs-toggle="collapse"
    role="button"
    aria-expanded="true"
    href="#btn-info-obra"
    (click)="
      $event.stopPropagation();
      filtroDetalhesObra.length > 0 && dropdown.toggle()
    "
    (keydown.enter)="filtroDetalhesObra.length > 0 && dropdown.toggle()"
    (keydown.space)="filtroDetalhesObra.length > 0 && dropdown.toggle()"
  >
    <img
      class="img-icon"
      [ngClass]="{ 'girar-icon': dropdown.isOpen }"
      src="{{
        BASE_IMG_URL
      }}assets/filtro-lateral-busca/icone-seta-fechar.svg"
      alt=""
      width="18"
      height="18"
    />
  </a>
</div>
<div
  class="dropdown-tipo-obra"
  *ngIf="dropdown.isOpen && filtroDetalhesObra.length > 0"
>
  <ul>
    <li *ngFor="let option of filtroDetalhesObra; let i = index">
      <div class="form-check">
        <input
          type="checkbox"
          class="form-check-input checkbox tipo-de-obra"
          [id]="option['id']"
          name="checkbox_{{ option['id'] }}"
          [(ngModel)]="option['checked']"
          (change)="onDetalheChange()"
          (click)="$event.stopPropagation()"
        />
        <label class="form-check-label" [for]="option['id']">
          {{ option["description"] }}
        </label>
      </div>
    </li>
  </ul>
</div>
